(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('GeodataDetailController', GeodataDetailController);

    GeodataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Geodata'];

    function GeodataDetailController($scope, $rootScope, $stateParams, entity, Geodata) {
        var vm = this;
        vm.geodata = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:geodataUpdate', function(event, result) {
            vm.geodata = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
